export const fr = {
  impact_card: {
    your_volunteering: 'Votre bénévolat',
    volunteering_at: 'Le bénévolat à',
    the_rest: 'Tendances',
    hours_volunteered: 'Heures de bénévolat',
    opportunities_attended: 'Activités auxquelles vous avez participé',
    department_rank: 'Classement de votre service',
    total_hours_volunteered: 'Total des heures de bénévolat',
    top_cause: 'Cause la plus populaire',
    top_nonprofit: 'Organisme de bienfaisance le plus populaire',
    view_impact: 'Statistiques sur notre impact pour {{year}}',
  }
}